import { useState } from 'react';
import { VideoThumb } from '@/pages/Videos';

/**
 * InlinePlayer — one-click YouTube play, in place. Renders the thumbnail
 * with the play affordance until the user activates it, then swaps to a
 * youtube-nocookie iframe with `autoplay=1`. YouTube honours autoplay
 * because the iframe was mounted as a direct result of a user click.
 *
 * - No page navigation.
 * - No intermediate state.
 * - Never remounts on route changes.
 * - Keyboard-accessible (button, Enter/Space activates).
 */
export default function InlinePlayer({ video, testid }) {
    const [playing, setPlaying] = useState(false);

    if (playing) {
        return (
            <div className="img-wrap aspect-[16/10] relative" style={{ background: '#000' }} data-testid={testid ? `${testid}-player` : 'inline-player'}>
                <iframe
                    src={`https://www.youtube-nocookie.com/embed/${video.youtube_id}?autoplay=1&rel=0&modestbranding=1&playsinline=1`}
                    title={video.title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                    frameBorder="0"
                    className="absolute inset-0 w-full h-full"
                    data-testid={testid ? `${testid}-iframe` : 'inline-iframe'}
                />
            </div>
        );
    }

    return (
        <button
            type="button"
            onClick={() => setPlaying(true)}
            aria-label={`Play ${video.title}`}
            className="block w-full text-left"
            style={{ background: 'transparent', border: 0, padding: 0, cursor: 'pointer' }}
            data-testid={testid ? `${testid}-play-btn` : 'inline-play-btn'}
        >
            <VideoThumb video={video} />
        </button>
    );
}
